import type { FC } from 'react';
import Content from '../Content';
import { WidthProperties } from '../../../../../../core/domain/map';

type Props = {
    networkProperties: WidthProperties | null;
};

const RoadDataPopupOnHover: FC<Props> = ({ networkProperties }) => {
    if (!networkProperties) {
        return null;
    }

    return <Content properties={networkProperties} />;
};

export default RoadDataPopupOnHover;
